// src/pages/ServicesPage.tsx
import React, { useEffect, useMemo } from "react";
import { useLocation, Link } from "react-router-dom"; // Import Link for breadcrumbs
import servicebg from "../assets/img/privavcy-bg.jpg"; // Update with the correct path to your hero image
import ServiceDetailSection from "../sections/Services/Services/ServiceDetailSection";
import {
  digitalMarketingServices,
  softwareDevelopmentServices,
} from "../sections/Services/Services/servicesData";
import softwareServiceImg from "../assets/img/services-details/services-1.jpg"; // Update with the correct path to your image
import DigitalMarketingServiceImg from "../assets/img/services-details/services-2.jpg"; // Update with the correct path to your image
import ContactUs from "../sections/Services/ContactUs/ContactUs";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
// You might want to import your hero background image
// import servicesHeroBg from '../assets/images/your-services-hero-bg.jpg';
// Or if it's in public: const servicesHeroBg = "/img/services-details/hero-bg.jpg"; // Update with actual path

const ContactPage: React.FC = () => {
  const apiKey = process.env.REACT_APP_Maps_API_KEY || "";

  // Check if API key is missing for debugging/developer feedback
  useEffect(() => {
    if (!apiKey) {
      console.error(
        "Google Maps API key is missing! Please ensure REACT_APP_Maps_API_KEY is set in your .env file."
      );
      // You could also render a fallback UI here, e.g., a message instead of the map
    }
  }, [apiKey]); // Run this effect only when apiKey changes

  const containerStyle = {
    width: "100%",
    height: "450px",
  };

  const center = {
    lat: 18.473287, // Replace with your latitude
    lng: 73.855189, // Replace with your longitude
  };

  return (
    <div className="services-main-wrapper">
      {" "}
      {/* Overall container */}
      {/* Start Page Title Area - This needs to match your design's hero section */}
      <div
        className="page-title-area bg-custom-overlay relative z-0"
        style={{ height: "400px" }}
      >
        {" "}
        {/* Add relative and z-0 for content to overlap */}
        {/* Background Image/Overlay: Using inline style for simplicity, but consider a dedicated CSS class */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url('${servicebg}')`, zIndex: 1 }} // No height here, inset-0 covers parent
        ></div>
        {/* Dark overlay: Also covers the parent's 500px height */}
        <div className="absolute inset-0 bg-slate-600 opacity-55"></div>{" "}
        {/* Adjust opacity as needed */}
        <div className="relative z-10 d-table min-h-[300px] flex items-center w-full">
          {" "}
          {/* Adjusted for height and centering */}
          <div className="d-table-cell w-full">
            <div className="container mx-auto px-4 max-w-6xl text-center text-white">
              <div className="page-title-content">
                <h2 className="text-5xl font-bold mb-3">Services Details</h2>
                <ul className="flex justify-center space-x-2 text-lg">
                  <li>
                    <Link to="/" className="hover:underline">
                      Home
                    </Link>
                  </li>
                  <li>/</li> {/* Separator */}
                  <li>Contact</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 my-5 max-w-7xl">
        <div className="text-center mb-12">
          <p className="text-it-solutions-orange uppercase text-sm font-semibold mb-2">
            Contact Us
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-[28px] font-bold text-it-text-dark">
            Let's Talk
          </h2>
        </div>
        <ContactUs id="contactus" />
      </div>
      <div className="w-full h-[400px] md:h-[500px] overflow-hidden rounded-xl shadow-lg">
        <LoadScript googleMapsApiKey={apiKey}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={15}
          >
            <Marker position={center} />
          </GoogleMap>
        </LoadScript>
      </div>
    </div>
  );
};

export default ContactPage;
